import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const FinishOperationModal = ({ open, onClose, onConfirm, loading, title }) => {
  return (
    <Dialog open={open} onClose={onClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ثبت اتمام عملیات</DialogTitle>
      <DialogContent>
        <Typography>
          {title
            ? `آیا از اتمام عملیات «${title}» مطمئن هستید؟`
            : 'آیا از اتمام این عملیات مطمئن هستید؟'}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={onConfirm}
          loading={loading}
        >
          ثبت
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default FinishOperationModal;
